import { Deserializer as JSONAPIDeserializer } from "jsonapi-serializer";

export default JSONAPIDeserializer;
